export default __webpack_public_path__ + "static/media/img8.084f41bf.jpg";